import { applicationCatalog } from "./catalog";

/** Keep this normalization aligned with the API's custom application contract. */
export function normalizeCustomApplicationName(value: string): string {
  return value.normalize("NFKC").trim().replace(/\s+/gu, " ");
}

const nameKey = (value: string) => value.normalize("NFKC").toLowerCase().replace(/[^\p{L}\p{N}]+/gu, "");
// Include the retired Google catalog item and policy aliases. Custom names must
// not sidestep existing permanent-only, SCIM, or account-creation policies.
const reservedNames = new Set([
  ...applicationCatalog.flatMap(app => [app.id, app.name]),
  "google-account", "Google Account (For GCP / BigQuery)",
  "Claude", "Anthropic Claude", "ChatGPT", "OpenAI ChatGPT", "GCP Account",
].map(nameKey));

export function customApplicationNameError(value: string): string {
  const name = normalizeCustomApplicationName(value);
  if (name.length < 2 || name.length > 200 || /[\p{Cc}\p{Cf}]/u.test(name)) return "Enter the custom application name (2–200 characters, without hidden control characters).";
  if (reservedNames.has(nameKey(name))) return "Choose the existing application from the catalogue instead of using Custom application. For GCP account creation, use GCP Account under Admin / Dev access.";
  return "";
}
